import { Row, Col, Card, Button } from 'react-bootstrap';

interface AmuraData {
  ID: number;
  CrmClientID: string;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  healthObjectives?: string;
  age?: string;
  gender?: string;
  weight?: string;
  height?: string;
  EmployeeNumber: string;
  InsertDateTime: string;
}

type Props = {
  requests: AmuraData[];
  onAddRequest: () => void;
};

const AmuraList: React.FC<Props> = ({ requests, onAddRequest }) => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h6 className="mb-0">Your Requests ({requests.length})</h6>
        <Button variant="primary" size="sm" onClick={onAddRequest}>
          + Add Request
        </Button>
      </div>
      <Row>
        {requests.map((request) => {
          return (
            <Col md={12} key={request.ID} className="mb-4">
              <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">{request.firstName} {request.lastName}</h5>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <h6 className="text-muted mb-3">Contact Information</h6>
                      <p className="mb-2"><strong>Name:</strong> {request.firstName} {request.lastName}</p>
                      <p className="mb-2"><strong>Email:</strong> {request.email}</p>
                      <p className="mb-2"><strong>Phone:</strong> {request.mobileNumber}</p>
                    </Col>
                    <Col md={6}>
                      <h6 className="text-muted mb-3">Health Details</h6>
                      {request.age && <p className="mb-2"><strong>Age:</strong> {request.age}</p>}
                      {request.gender && <p className="mb-2"><strong>Gender:</strong> {request.gender}</p>}
                      {request.weight && <p className="mb-2"><strong>Weight:</strong> {request.weight} kg</p>}
                      {request.height && <p className="mb-2"><strong>Height:</strong> {request.height} cm</p>}
                    </Col>
                  </Row>
                  {request.healthObjectives && (
                    <>
                      <hr />
                      <Row>
                        <Col md={12}>
                          <h6 className="text-muted mb-2">Health Objectives</h6>
                          <p className="mb-0">{request.healthObjectives}</p>
                        </Col>
                      </Row>
                    </>
                  )}
                  <hr />
                  <p className="mb-0 text-muted small">Submitted: {new Date(request.InsertDateTime).toLocaleDateString()}</p>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export { AmuraList };
export type { AmuraData };
